export default "__VITE_ASSET__8$_ScrZ$__"